import React from "react";
import {
  ContactPage,
  ContactInner,
  ContactRow,
  ContactCol,
  ContactContentText,
  ContactImage,
  ContactContentTextFooter,
  ButtonRow,
  CTAButton
} from "./ContactElements";
import ContactForm from "./ContactForm";
import {
  DesktopOnly
} from "../CommonElements";
import contactPicture from "../../images/progress_studio.jpg";
import yourselfPicture from "../../images/YOURSELF.png";

const Contact = () => {
  return (
    <ContactPage>
      <ContactInner>
        {/* Row 1: text + image */}
        <ContactRow>
          <ContactCol>
            <ContactContentText style={{ fontSize: 18 }}>
              Tell us about your vision or project.
              <br />
              We are here to bring your ideas to life.
              <br />
              <br />
              You can reach us by call, email, or through
              <br />
              our quick form — whatever works best for you.
            </ContactContentText>
            <ButtonRow>
              <CTAButton href="tel:+447736584565" aria-label="Call">
                📞 Call
              </CTAButton>
              <CTAButton href="mailto:progressstudio.info@gmail.com" aria-label="Email">
                ✉️ Email
              </CTAButton>
              <CTAButton as="button"   
                      onClick={() =>
                        window.scrollTo({
                          top: document.documentElement.scrollHeight,
                          behavior: "smooth",
                        })
                      } 
                      aria-label="Quick Form">
                📝 Quick Form
              </CTAButton>
            </ButtonRow>
          </ContactCol>
          <ContactCol>
            <ContactImage src={contactPicture} alt="Progress Studio" />
          </ContactCol>
        </ContactRow>

        {/* Row 2: contact info + form */}
        <ContactRow>
          <ContactCol>
            <DesktopOnly style={{background: "#282c34"}}>
              <ContactImage src={yourselfPicture} alt="Progress Studio" />
            </DesktopOnly>
            <ContactContentText>
              <ContactContentTextFooter>Photography and Videography services based in the UK</ContactContentTextFooter>
            </ContactContentText>
          </ContactCol>

          <ContactCol>
            <ContactForm />
          </ContactCol>
        </ContactRow>
      </ContactInner>
    </ContactPage>
  );
};

export default Contact;
